import { useAuthContext } from "@/contexts/AuthContext";
import { useQRStats } from "@/hooks/useQRStats";
import { mockScanStats } from "@/mocks/statistics";

interface Props {
  stats?: ReturnType<typeof useQRStats>["stats"];
}

export default function StatsSummary({ stats }: Props) {
  const { user } = useAuthContext();
  const { stats: liveStats, loading } = useQRStats();
  const s = stats || liveStats;

  const cards = s
    ? [
        {
          label: "Toplam Tarama",
          value: s.totalScans.toLocaleString("tr-TR"),
          change: 12.4,
          icon: "ri-qr-scan-2-line",
          color: "bg-emerald-50 text-emerald-600",
        },
        {
          label: "Bugün",
          value: s.todayScans.toLocaleString("tr-TR"),
          change: 8.7,
          icon: "ri-calendar-check-line",
          color: "bg-teal-50 text-teal-600",
        },
        {
          label: "Bu Hafta",
          value: s.weekScans.toLocaleString("tr-TR"),
          change: -3.2,
          icon: "ri-bar-chart-line",
          color: "bg-cyan-50 text-cyan-600",
        },
        {
          label: "Benzersiz Kullanıcı",
          value: s.uniqueUsers.toLocaleString("tr-TR"),
          change: 15.1,
          icon: "ri-user-line",
          color: "bg-emerald-50 text-emerald-600",
        },
      ]
    : [
        {
          label: "Toplam Tarama",
          value: mockScanStats.total.toLocaleString("tr-TR"),
          change: mockScanStats.totalChange,
          icon: "ri-qr-scan-2-line",
          color: "bg-emerald-50 text-emerald-600",
        },
        {
          label: "Bugün",
          value: mockScanStats.today.toLocaleString("tr-TR"),
          change: mockScanStats.todayChange,
          icon: "ri-calendar-check-line",
          color: "bg-teal-50 text-teal-600",
        },
        {
          label: "Bu Hafta",
          value: mockScanStats.thisWeek.toLocaleString("tr-TR"),
          change: mockScanStats.weekChange,
          icon: "ri-bar-chart-line",
          color: "bg-cyan-50 text-cyan-600",
        },
        {
          label: "Benzersiz Kullanıcı",
          value: mockScanStats.uniqueUsers.toLocaleString("tr-TR"),
          change: mockScanStats.uniqueChange,
          icon: "ri-user-line",
          color: "bg-emerald-50 text-emerald-600",
        },
      ];

  if (!user) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((card) => (
          <div key={card.label} className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${card.color}`}>
                <i className={`${card.icon} text-lg`}></i>
              </div>
              <span className={`text-xs font-semibold flex items-center gap-1 ${card.change >= 0 ? "text-emerald-600" : "text-red-500"}`}>
                <i className={card.change >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                {Math.abs(card.change)}%
              </span>
            </div>
            <div className="text-2xl font-bold text-gray-900">{card.value}</div>
            <div className="text-xs text-gray-500 mt-1">{card.label}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white rounded-2xl border border-gray-100 p-5">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${card.color}`}>
              <i className={`${card.icon} text-lg`}></i>
            </div>
            <span className={`text-xs font-semibold flex items-center gap-1 ${card.change >= 0 ? "text-emerald-600" : "text-red-500"}`}>
              <i className={card.change >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
              {Math.abs(card.change)}%
            </span>
          </div>
          <div className="text-2xl font-bold text-gray-900">{loading && !s ? "—" : card.value}</div>
          <div className="text-xs text-gray-500 mt-1">{card.label}</div>
        </div>
      ))}
    </div>
  );
}